<template>
  <div>
    <div v-show="loading">
      <div class="service-width">
        <p class="menuPageTitle">포인트 주문 목록</p>
        <p class="menuPageSubTitle">
          포인트 상품을 결제한 내역에 대해 확인이 가능합니다.
        </p>
        <p class="menuPageSubTitle">
          부득이하게 주문건 취소처리하시는 경우에는 지급된 적립금을 필히
          확인하시고 취소여부를 진행하시길 권장합니다.
        </p>
      </div>

      <div class="service-width">
        <OrderSearch ref="OrderSearch"></OrderSearch>
      </div>
      <div>
        <OrderList ref="OrderList"></OrderList>
      </div>
    </div>

    <PageLoadingProgress ref="PageLoadingProgress"></PageLoadingProgress>
  </div>
</template>
<script>
import OrderSearch from "@/components/mileage/order/component/OrderSearch.vue";
import OrderList from "@/components/mileage/order/component/OrderList.vue";
import PageLoadingProgress from "@/components/common/PageLoadingProgress.vue";
export default {
  data: () => {
    return {
      loading: false,
    };
  },
  methods: {
    loadCompleted: function() {
      this.$refs.PageLoadingProgress.hide();
      this.loading = true;
    },
  },
  components: {
    OrderSearch,
    OrderList,
    PageLoadingProgress,
  },
  mounted: async function() {
    this.$refs.PageLoadingProgress.show();
  },
};
</script>
